<template>
  <div>
    <div class="card p-10 pt-15">
      <div class="card-body px-20 form-detail">
        <Content title="Serial thiết bị" :content="item.serial" />
        <Content title="Người thay đổi" :content="`${item.createByName} - ${item.createByEmail}`" />
        <Content title="Hành động">
          {{ item.action | transformData(Config.deviceLocationHistoryAction) }}
        </Content>
        <Content title="Lý do" :content="item.reason" />
        <Content title="Thời gian" :content="item.createAt | formatDate('HH:mm, DD/MM/YYYY')" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-detail">
          <h3>Trước thay đổi</h3>
          <Content
            title="Loại thiết bị"
            :content="item.oldDeviceType | transformData(deviceTypeOptions)"
          />
          <Content
            title="Loại PL/BB"
            :content="item.oldTypeAppendix | transformData(typeAppendixOptions)"
          />
          <Content title="Tên merchant" :content="item.oldMerchantName" />
          <Content title="Email" :content="item.oldEmail" />
          <Content title="Tên ĐCNTT" :content="item.oldAreaName" />
          <Content title="Địa chỉ" :content="item.oldAreaAddress" />
          <Content title="Trạng thái">
            <Status :value="item.oldStatus" :config="statusOptions" />
          </Content>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-detail">
          <h3>Sau thay đổi</h3>
          <Content
            title="Loại thiết bị"
            :content="item.newDeviceType | transformData(deviceTypeOptions)"
          />
          <Content
            title="Loại PL/BB"
            :content="item.newTypeAppendix | transformData(typeAppendixOptions)"
          />
          <Content title="Tên merchant" :content="item.newMerchantName" />
          <Content title="Email" :content="item.newEmail" />
          <Content title="Tên ĐCNTT" :content="item.newAreaName" />
          <Content title="Địa chỉ" :content="item.newAreaAddress" />
          <Content title="Trạng thái">
            <Status :value="item.newStatus" :config="statusOptions" />
          </Content>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { MerchantService } from '@/services/merchant.service'
  export default {
    props: {
      id: String,
      deviceTypeOptions: Array,
      typeAppendixOptions: Array,
      statusOptions: Array,
    },
    data() {
      return {
        item: {},
        showLoading: false,
      }
    },
    async created() {
      try {
        this.showLoading = true
        await this.fetchData()
      } catch (error) {
      } finally {
        this.showLoading = false
      }
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const res = await MerchantService.detailHistoryDeviceLocation(this.id)
          this.item = res.data
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped></style>
